"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkFirst = void 0;
var open_cache_1 = require("../_utils/open-cache");
var network_first_with_timeout_1 = require("./network-first-with-timeout");
var network_first_simple_1 = require("./network-first-simple");
var NetworkFirst = /** @class */ (function () {
    function NetworkFirst(_a) {
        var _this = this;
        var timestamp = _a.timestamp, storageCacheName = _a.storageCacheName, requestCacheKey = _a.requestCacheKey, debugCacheLogger = _a.debugCacheLogger;
        this.cacheRequest = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var cache, response, strategyClassParams, strategyClass, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugCacheLogger.openLogsGroup({
                            requestCacheKey: this.requestCacheKey,
                        });
                        this.debugCacheLogger.logParams({
                            params: JSON.stringify({
                                strategy: 'NetworkFirst',
                                expiresToDate: params.expiresToDate,
                                disabledCache: params.disabledCache,
                                'api-expires': this.timestamp + (params.expires || 0),
                                timestamp: this.timestamp,
                                storageCacheName: this.storageCacheName,
                                requestCacheKey: this.requestCacheKey,
                            }),
                        });
                        return [4 /*yield*/, (0, open_cache_1.openCache)(this.storageCacheName)];
                    case 1:
                        cache = _a.sent();
                        if (!(params.disabledCache || !window.caches || !cache)) return [3 /*break*/, 3];
                        return [4 /*yield*/, params.request()];
                    case 2:
                        response = _a.sent();
                        this.debugCacheLogger.logDisabledCache();
                        this.debugCacheLogger.closeLogsGroup();
                        return [2 /*return*/, response];
                    case 3:
                        strategyClassParams = {
                            timestamp: this.timestamp,
                            storageCacheName: this.storageCacheName,
                            requestCacheKey: this.requestCacheKey,
                            debugCacheLogger: this.debugCacheLogger,
                        };
                        strategyClass = params.timeout
                            ? new network_first_with_timeout_1.NetworkFirstWithTimeout(strategyClassParams)
                            : new network_first_simple_1.NetworkFirstSimple(strategyClassParams);
                        return [4 /*yield*/, strategyClass.cacheRequest(__assign(__assign({}, params), { cache: cache }))];
                    case 4:
                        result = _a.sent();
                        // todo fix request update cache with timer
                        this.debugCacheLogger.closeLogsGroup();
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.timestamp = timestamp;
        this.storageCacheName = storageCacheName;
        this.requestCacheKey = requestCacheKey;
        this.debugCacheLogger = debugCacheLogger;
    }
    return NetworkFirst;
}());
exports.NetworkFirst = NetworkFirst;
